import React from "react";
import {
  Box, Grid,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Paper
} from '@material-ui/core';
import { AlignCenter } from "react-feather";


export default class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      printDateTime: new Date().toLocaleString()
    };
  }

  render() {
    const groups = this.props.groups;
    const generalJournal = this.props.generalJournal;
    const factories = this.props.factories;
    const transactionModes = this.props.transactionModes;
    const accountTypeNames = this.props.accountTypeNames;
    const selectedDate = this.props.selectedDate;
    const journalData = this.props.journalData;
    const { printDateTime } = this.state;

    let totalCredit = 0;
    let totalDebit = 0;
    journalData.forEach(x => {
      totalCredit += x.credit
      totalDebit += x.debit
    });

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
        <div
          style={{
            fontFamily: 'sans-serif',
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className="record-container"
        >
          <div className="table-responsive row-top-gap">
            <div style={{ fontSize: "14px" }}>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{groups[generalJournal.groupID]}</p>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{factories[generalJournal.factoryID]}</p>
              <p style={{ textAlign: 'center', fontSize: "12px" }}>
                {generalJournal.transactionMode == 1 ? 'MAIN CASH RECEIVING' :
                  generalJournal.transactionMode == 2 ? 'GENERAL CASH RECEIVING' :
                    generalJournal.transactionMode == 3 ? 'CHEQUE RECEIVING' :
                      generalJournal.transactionMode == 7 ? 'TRANSFER RECEIVING' : ""
                }
              </p>
            </div>
            &nbsp;
            <Grid container style={{ fontSize: "14px" }}>
              <Grid container xs={8}>
                <Grid item xs={4}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "50px" }}
                  >
                    <p>Recipient</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>Description</p>
                  </div>
                </Grid>
                <Grid item xs={8}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "50px" }}
                  >
                    <p>{generalJournal.recipientName}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px", fontSize: "14px" }}
                  >
                    <p>{journalData.length != 0 ? journalData[0].description : ""}</p>
                  </div>
                </Grid>
              </Grid>
              <Grid container xs={4}>
                <Grid xs={6}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>V : NO</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>Date</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>CHQ No</p>
                  </div>
                </Grid>

                <Grid xs={6}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>{generalJournal.referenceNumber}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>{(selectedDate).split('T')[0]}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>{generalJournal.chequeNumber}</p>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <div>&nbsp;</div>
            <div></div>
            <Box>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <TableCell align={'left'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Acc Code</TableCell>
                      <TableCell align={'left'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Account Name</TableCell>
                      <TableCell align={'center'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Dr</TableCell>
                      <TableCell align={'center'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Cr</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ borderBottom: '1px solid black' }}>
                    {journalData.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell align={'left'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.selected[0].ledgerAccountCode}
                        </TableCell>
                        <TableCell align={'left'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.selected[0].ledgerAccountName}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.debit != 0 ? data.debit.toFixed(2) : ''}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', borderRight: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.credit != 0 ? data.credit.toFixed(2) : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontSize: "12px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell style={{ fontSize: "12px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell align={'right'} scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: "2px" }}>
                        {totalDebit.toFixed(2)}
                      </TableCell>
                      <TableCell align={'right'} scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: "2px" }}>
                        {totalCredit.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            &nbsp;
            <div
              align={"left"}
              style={{ fontSize: "14px", paddingBottom: '50px' }}
            >
              <p>I do hereby certify that I have paid Sum of Rupees <b>{totalCredit.toFixed(2)}</b> Only as<b /> detailed above from the management of {factories[generalJournal.factoryID]}.</p>
            </div>
            <div style={{ paddingBottom: "10px", fontSize: "14px" }} align={"right"}>
              Signature of Recipient
            </div>
            &nbsp;
            &nbsp;
            <Grid container spacing={2} style={{ fontSize: '14px' }}>
              <Grid item xs={12} sm={4}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ minHeight: '14px' }}>
                    {generalJournal.preparedBy == null || generalJournal.preparedBy == "" ? "" : generalJournal.preparedBy}
                  </div>
                  <div style={{ paddingTop: '1px' }}>
                    <b>Prepared By</b>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                   <div style={{ minHeight: '14px' }}>
                    {generalJournal.checkedBy == null || generalJournal.checkedBy == "" ? "" : generalJournal.checkedBy}
                  </div>
                  <div style={{ paddingTop: '1px' }}>
                    <b>Checked By</b>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                   <div style={{ minHeight: '14px' }}>
                    {generalJournal.checkedBy == null || generalJournal.checkedBy == "" ? "" : generalJournal.checkedBy}
                  </div>
                  <div style={{ paddingTop: '1px' }}>
                    <b>Approved By</b>
                  </div>
                </div>
              </Grid>
            </Grid>
            <div style={{ display: 'flex', justifyContent: 'flex-start', fontSize: "10px", padding: '10px 0', display: 'none' }}>
              <div>Printed: {printDateTime}</div>
            </div>
          </div>
        </div>
      </Paper>
    );
  }
}
